import { supabase } from './supabase';
import { t } from '../data/translations';

export interface RSVPResponse {
  id?: number;
  name: string;
  will_attend: boolean;
  day1: boolean;
  day2: boolean;
  overnight: 'один день' | 'два дня' | 'нет';
  plus_one: boolean;
  has_child: boolean;
  alcohol_preferences?: string;
  comment?: string;
  secret_key: string;
  created_at?: string;
}

export interface RSVPServiceResponse {
  success: boolean;
  data?: RSVPResponse;
  error?: string;
}

class RSVPService {
  async submitRSVP(rsvpData: Omit<RSVPResponse, 'id' | 'created_at'>): Promise<RSVPServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('rsvp_responses')
        .insert([rsvpData])
        .select()
        .single();

      if (error) {
        console.error('RSVP submission error:', error);
        return {
          success: false,
          error: t('windows.rsvp.errorMessage')
        };
      }

      return {
        success: true,
        data
      };

    } catch (error) {
      console.error('RSVP submission error:', error);
      return {
        success: false,
        error: t('windows.rsvp.errorMessage')
      };
    }
  }

  async getRSVPByKey(secretKey: string): Promise<RSVPServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('rsvp_responses')
        .select('*')
        .eq('secret_key', secretKey)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('RSVP fetch error:', error);
        return {
          success: false,
          error: 'Failed to fetch RSVP'
        };
      }

      if (!data || data.length === 0) {
        return {
          success: false,
          error: 'RSVP not found'
        };
      }

      // Берем самую новую запись (первую после сортировки по убыванию)
      return {
        success: true,
        data: data[0]
      };

    } catch (error) {
      console.error('RSVP fetch error:', error);
      return {
        success: false,
        error: 'Failed to fetch RSVP'
      };
    }
  }

  async getAllRSVPs(): Promise<RSVPServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('rsvp_responses')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('RSVP fetch error:', error);
        return {
          success: false,
          error: 'Failed to fetch RSVPs'
        };
      }

      return {
        success: true,
        data: data as RSVPResponse[]
      };

    } catch (error) {
      console.error('RSVP fetch error:', error);
      return {
        success: false,
        error: 'Failed to fetch RSVPs'
      };
    }
  }

  async updateRSVP(id: number, updates: Partial<RSVPResponse>): Promise<RSVPServiceResponse> {
    try {
      const { data, error } = await supabase
        .from('rsvp_responses')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error('RSVP update error:', error);
        return {
          success: false,
          error: 'Failed to update RSVP'
        };
      }

      return {
        success: true,
        data
      };

    } catch (error) {
      console.error('RSVP update error:', error);
      return {
        success: false,
        error: 'Failed to update RSVP'
      };
    }
  }
}

export const rsvpService = new RSVPService(); 